/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum PgHbaAuthenticationMethod {
  ScramSha256 = 'scram-sha-256',
  Md5 = 'md5',
  Trust = 'trust',
}
